const {
  REACT_APP_BASENAME,
  REACT_APP_POTENCIAL_TALENTO_APP_URL_BACK,
  REACT_APP_POTENCIAL_TALENTO_APP_URL,
  REACT_APP_POTENCIAL_TALENTO_APP_URL_AUTH,
  REACT_APP_GRUPO_NOMBRE_DADO_DE_BAJA,
} = process.env;

const config = {
  URL: {
    BASENAME: REACT_APP_BASENAME,
    POTENCIAL_TALENTO_APP_URL_BACK: REACT_APP_POTENCIAL_TALENTO_APP_URL_BACK,
    POTENCIAL_TALENTO_APP_URL: REACT_APP_POTENCIAL_TALENTO_APP_URL,
    POTENCIAL_TALENTO_APP_URL_AUTH: REACT_APP_POTENCIAL_TALENTO_APP_URL_AUTH,
    GRUPO_NOMBRE_DADO_DE_BAJA: REACT_APP_GRUPO_NOMBRE_DADO_DE_BAJA,
  },
  CONFIG_MODULE: {
    LOCALSTORAGE_KEY: 'potencial-talento-user-data',
  },
};

export default config;
